// Bundle Cart Handler - Applies bundle price to cart items
(function() {
  'use strict';

  console.log('Bundle Cart Handler loaded');

  // Store original fetch to intercept cart requests
  const originalFetch = window.fetch;

  window.fetch = function(...args) {
    // Only intercept cart add requests
    if (args[0] && args[0].includes('/cart/add')) {
      console.log('🛒 Cart Add Request Intercepted');
      handleCartAdd(...args);
    }
    return originalFetch.apply(this, args);
  };

  function handleCartAdd(url, options) {
    try {
      // Get the form data being submitted
      let formDataObj = {};
      
      if (options.body instanceof FormData) {
        // Convert FormData to object for logging
        for (let [key, value] of options.body.entries()) {
          formDataObj[key] = value;
        }
      } else if (typeof options.body === 'string') {
        // Parse URL-encoded form data
        const params = new URLSearchParams(options.body);
        for (let [key, value] of params.entries()) {
          formDataObj[key] = value;
        }
      }
      
      // Log all form data
      console.log('Form Data Being Submitted:', formDataObj);
      
      // Extract bundle information
      const bundlePrice = formDataObj['properties[Bundle Price]'];
      const bundleName = formDataObj['properties[Bundle]'];
      const productId = formDataObj['id'];
      const quantity = formDataObj['quantity'];
      
      if (bundleName || bundlePrice) {
        console.log('✅ Bundle Information Found in Cart Submission:', {
          bundlePrice: bundlePrice || 'N/A',
          bundleName: bundleName || 'N/A',
          productVariantId: productId,
          quantity: quantity
        });
      } else {
        console.warn('⚠️ No bundle information found in cart submission');
        console.log('Available properties:', {
          keys: Object.keys(formDataObj).filter(k => k.includes('properties'))
        });
      }
    } catch (error) {
      console.error('Error processing cart data:', error);
    }
  }

  // Listen for cart updates
  document.addEventListener('cart-update', (e) => {
    console.log('Cart updated event:', e.detail);
  });

  // Also monitor the product form submission
  document.addEventListener('submit', (e) => {
    if (e.target.matches('form[data-type="add-to-cart-form"]')) {
      console.log('🛒 Product form submitted (Add to Cart)');
      
      // Get all form data
      const formData = new FormData(e.target);
      let submitData = {};
      for (let [key, value] of formData.entries()) {
        submitData[key] = value;
      }
      
      console.log('📝 Form Submission Data:', submitData);
      
      const bundleSelected = submitData['properties[Bundle]'];
      const bundlePrice = submitData['properties[Bundle Price]'];
      
      if (bundleSelected) {
        console.log('✅ Bundle will be added to cart:', {
          bundle: bundleSelected,
          price: bundlePrice
        });
      }
    }
  });
})();
